import axios from 'axios';
import { call } from 'redux-saga/effects';
import { UPLOAD_ENDPOINT } from '../config/apiEndpoints';

const headers = {};

export function* upload(payload) {    
    return yield call(axios.post, UPLOAD_ENDPOINT, payload, headers);
}



// WEBPACK FOOTER //
// ./src/SHARED/api/image.api.js